var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssetsShell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.41 195.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        stroke: #ffd510;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke-dasharray: 10.34 10.34;\n      }\n\n      .st2 {\n        stroke-width: 1.36px;\n      }\n\n      .st2, .st3 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st3 {\n        stroke-width: 1.4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.51,160.9c-2.67-5.24-5.8-9.14-9.64-13.33-46.55-50.73-4.68-91.41-4.68-91.41,0,0,28.24-17.02,45.58-9.11,0,0,18.15,21.2,2.65,46.89-12.78,21.19-23.35,19.77-29.86,28.12-2.37,3.04-3.66,6.79-3.79,10.65-.15,4.48-.07,12.07,1.74,17.23.45,1.27.32,2.68-.42,3.81-1.85,2.83-4.25,8.92,4.19,13.38,10.19,5.39,33.52-4.1,42.82-30.58,7.27-20.71-6.51-39.15-10.46-51.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.78,91.52c5.89,8.17,23.6,37.01,1.36,64.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.19,56.15c-.16-17.18,12.6-25.23,12.6-25.23,0,0,11.37-7.63,28.16-3.68,0,0,7.41,11.03,4.82,19.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.78,30.92c-.57-7.63,7.49-13,7.49-13,0,0,10.98-4.89,16.96,0,3.06,2.49,3.75,6.36,3.75,9.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.14,17.88c.43-1.46,1.56-4.07,4.26-5.34,0,0,5.53-2.09,10.14-.38,0,0,2.15,1.84,2.16,5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.23,12.48c.29-.88.98-2.18,2.64-2.95,0,0,4.18-1.23,6.16-.21,0,0,1.46,1.02,1.6,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.01,9.49c.17-.63.53-1.51,1.28-1.89.49-.25,1.07-.36,1.6-.41,1.15-.1,2.29.48,2.78,1.53.05.1.19.42.22.52"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 46.75,
    y1: 68.61,
    x2: 46.75,
    y2: 90.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "39.63 75.7 46.75 68.58 53.87 75.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 97.33,
    y1: 76.9,
    x2: 102.33,
    y2: 76.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.67,76.9h6.66c4.25,0,7.69,3.44,7.69,7.69v96.13c0,4.25-3.44,7.69-7.69,7.69H13.08c-4.25,0-7.69-3.44-7.69-7.69v-39.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.39,
    y1: 136.51,
    x2: 5.39,
    y2: 131.51
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssetsShell);
export default __webpack_public_path__ + "static/media/SVG_assets_shell.e80045d8a16f7cfe7685fe251138cf07.svg";
export { ForwardRef as ReactComponent };